/**
 * This class is used to validate input from users which matches common patterns, such as e-mail addresses and telephone numbers.
 */
export class Validate {

	/**
	 * Validates that a string is in the format of an e-mail address.
	 *
	 * @param Email The string to check the format of.
	 */
	public static ValidateEmail(Email: string): boolean {
		return Validate.ValidateData(Email, /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i);
	}

	/**
	 * Validates that a string is in the format of a phone number.
	 *
	 * @param PhoneNumber The string to check the format of.
	 */
	public static ValidatePhoneNumber(PhoneNumber: string): boolean {
		return Validate.ValidateData(PhoneNumber, /^\(?\d{3}\)?( |\.|-)?\d{3}( |\.|-)?\d{4}$/);
	}

	/**
	 * Validates that a string is in the format of an American or Canadian postal code.
	 *
	 * @param PostalCode The string to check the format of.
	 */
	public static ValidatePostalCode(PostalCode: string): boolean {
		return Validate.ValidateData(PostalCode, /^(\d{5}(-\d{4})?|[A-Z]{3} ?\d{3})$/);
	}

	/**
	 * Validates that a string is in the format of a positive whole number with 9 or less digits.
	 *
	 * @param Number The string to check the format of.
	 */
	public static ValidateWholeNumber(Number: string): boolean {
		return Validate.ValidateData(Number, /^\d{1,9}$/);
	}

	public static ValidateMoney(Money: string): boolean {
		return Validate.ValidateData(Money, /^\d{0,7}(\.\d{0,2})?$/);
	}

	/**
	 * Validates that a string is in the format of a short date (MM/dd/yyyy).
	 *
	 * @param DateString The string to check the format of.
	 */
	public static ValidateShortDate(DateString: string): boolean {
		let intDate: number;

		if (Validate.ValidateData(DateString, /^(1(0|1|2)|0?[1-9])\/(3[0-1]|(1|2)\d{1}|0?[1-9])\/2\d{3}$/)) {
			intDate = Date.parse(DateString);
			return !isNaN(intDate);
		}
		else
			return false;
	}

	/**
	 * Validates that a string is in the format of a short, 24-hour time (HH:mm).
	 *
	 * @param TimeString The string to check the format of.
	 */
	public static ValidateShortTime(TimeString: string): boolean {
		let strDate: string;
		let intDate: number;

		if (Validate.ValidateData(TimeString, /^(2[0-4]|1\d{1}|0?[0-9]):[0-5]\d{1}$/)) {
			strDate = `1/1/2000 ${TimeString}`;
			intDate = Date.parse(strDate);
			return !isNaN(intDate);
		}
		else
			return false;
	}

	/**
	 * Validates that a given string is letters and numbers only.
	 * 
	 * @param input The input against which you'd like to check.`
	 */
	public static ValidateHawbFormat (input: string): boolean {
		return this.ValidateData(input, /^[a-zA-Z0-9-.]+$/)
	}

	/**
	 * Validates that a string is not null or empty and that it matches the format of the regular expression parameters.
	 *
	 * @param Data The string to check the format of.
	 * @param RegEx The regular expression which is used to check the format of the string with.
	 */
	private static ValidateData(Data: string, RegEx: RegExp): boolean {
		if (Data == null || Data === "")
			return false
		else
			return RegEx.test(Data);
	}
	
}